import React, {useEffect, useState} from 'react';
import styles from '../SwapMain.module.css';

import usdtImg from "../static_files/usdt 1.svg";
import usdcImg from "../static_files/usdc.svg";
import usdImg from "../static_files/usd.svg";
import verticalLineImg from "../static_files/verticalLine.svg";
import dropDownRightImg from "../static_files/dropdownright.svg";
import dropDownRightHoverImg from "../static_files/dropdownrightHover.svg";
import dropDownImg from "../static_files/dropdown.svg";
import dropDownHoverImg from "../static_files/dropdownHover.svg";

import copySelectorImg from "../static_files/copy-selector.svg";
import copySelectorHoverImg from "../static_files/copy-selector-hover.svg";
import copyConfirmImg from "../static_files/copyConfirmMobile.png";
import shareSelectorImg from "../static_files/share-selector.svg";
import shareSelectorHoverImg from "../static_files/share-selector-hover.svg";
import {formatNumberWithCommas} from "../utils";

import WireIcon from '../static_files/Wire.svg';
import USDIcon from '../static_files/usd.svg';
import WireTransfer from "./WireTransfer";
import WireDetails from "./WireDetails";

/**
 * 这是专门提取出来的“MintTab”组件，
 * 完全保留你在 SwapMainAPP 里 {selectedTab === 'mint' && (...)} 部分的代码。
 * 父组件必须通过 props 将用到的所有数据、函数、状态、ref 等传进来。
 */
const MintTab = (props) => {
    const {
        typedMintValue,
        dynamicFontSize,
        containerRef,
        spanRef,
        inputRef,
        handleInputChange,
        handleSetMax,
        usdcBalance,
        usdtBalance,
        selectedToken,
        shortenAddress,
        walletAddress,
        showTokenSelector,
        methodItemRef,
        handleMethodItemClick,
        tokenSelectorRef,
        handleSelectToken,
        handleCopy,
        justCopiedUSDC,
        justCopiedUSDT,
        handleShare,
        // 第二个下拉：
        showTokenSelector3,
        methodItemRef3,
        handleMethodItemClick3,
        tokenSelectorRef3,
        iconMap,
        getPaymentInfoDisplay,
        walletAddressExists,
        handleMintUSDi,
        handleConnectWallet,
        usdcTokenAddress,
        usdtTokenAddress,
        userClass,
        showNotification
    } = props;
    const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);
    const paymentInfoData = [
        {
            account_number: "374004472836",
            amount_limit: null,
            bank_address: "100 W 33RD ST, 4th FL, New York, NY 10001 US",
            bank_country: "United States",
            bank_name: "Bank of America",
            default_payment: false,
            delivery_address: null,
            email: null,
            email_address: null,
            fees: null,
            mobile_number: null,
            payment_info_id: null,
            payment_method: "Bank Wire",
            processing_time: null,
            recipient_address: null,
            recipient_name: "DeFiner Holdings Inc.",
            swift_bic_code: "BOFAUS3N",
            us_routing_no: "026009593",
            wallet_address: null
        }
    ];
    const selectedPaymentMethod = availablePaymentMethods[0]


    const methodIcon = selectedPaymentMethod
        ? iconMap[selectedPaymentMethod.payment_method] || WireIcon
        : WireIcon;
    const [showWireTransfer, setShowWireTransfer] = useState(false)
    const [showWireDetails, setShowWireDetails] = useState(false)


    useEffect(() => {
        async function fetchAvailablePaymentMethods() {
            try {
                const res = await fetch(
                    'https://max1-funding-arb.uc.r.appspot.com/available_payment_method'
                );
                let data = await res.json();
                let formatted = data.map((item) => ({
                    ...item,
                    icon: iconMap[item.method_name] || USDIcon,
                }));

                const desiredOrder = [
                    'Bank Wire',
                    'Physical Cash',
                    'Zelle',
                    'Venmo',
                    'Alipay'
                ];
                formatted.sort((a, b) => {
                    return (
                        desiredOrder.indexOf(a.method_name) - desiredOrder.indexOf(b.method_name)
                    );
                });
                setAvailablePaymentMethods(formatted);
            } catch (error) {
                console.error('Error fetching payment methods:', error);
            }
        }

        fetchAvailablePaymentMethods();
    }, []);

    const stableBalance =
        selectedToken === 'USDT'
            ? usdtBalance
            : usdcBalance;
    const typedAmount = parseFloat(typedMintValue) || 0;
    const balanceNum = parseFloat(stableBalance) || 0;
    let enoughBalance
    if (!walletAddress) {
        enoughBalance = true
    } else {
        enoughBalance = typedAmount <= balanceNum;
    }
    return (
        <div className={styles.withdrawSection}>
            <div
                className={`${styles.withdrawSectionMiddle} `}
                style={{height: selectedToken === 'CASH' ? '430px' : '343px'}}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: '#1c1c1c',
                        position: 'relative'
                    }}
                >
                    <div
                        ref={containerRef}
                        className={`${styles.customInputWrapper} ${styles.customInputWrapper2}`}
                        style={{
                            position: 'relative',
                            height: '150px'
                        }}
                        onClick={() => inputRef.current?.focus()}
                    >
                        <input
                            ref={inputRef}
                            type="text"
                            className={styles.withDrawBig}
                            value={formatNumberWithCommas(typedMintValue)}
                            onChange={handleInputChange}
                            style={{
                                fontSize: dynamicFontSize,
                                border: 'none',
                                color: (selectedToken !== "CASH" && !enoughBalance) || (selectedToken === "CASH" && typedAmount < 10000 && typedAmount !== 0) ? 'red' : 'inherit',
                                background: 'transparent',
                                caretColor: '#6CE3C4',
                            }}
                        />
                        <span
                            ref={spanRef}
                            style={{
                                position: 'absolute',
                                visibility: 'hidden',
                                whiteSpace: 'pre',
                                padding: 0,
                                margin: 0
                            }}
                            onClick={() => inputRef.current?.focus()}
                        />
                        <span
                            className={styles.fakePlaceholderFont}
                            style={{
                                width: '12px',
                                background: 'transparent',
                                color: 'gray',
                                fontSize: dynamicFontSize
                            }}
                            onClick={() => inputRef.current?.focus()}
                        >
                            {' '}USDi
                        </span>
                        {
                            selectedToken === "CASH" ? <button
                                    className={styles.disabledMaxButton}
                                    disabled style={{opacity: 0.5, background: 'white'}}
                                >
                                    Max
                                </button> :
                                <button
                                    className={styles.maxButton}
                                    onClick={handleSetMax}
                                >
                                    Max
                                </button>
                        }

                    </div>

                </div>

                {selectedToken !== "CASH" ? <div className={styles.withDrawAmount}>
                    {stableBalance && stableBalance !== "--"
                        ? `${stableBalance.toLocaleString(undefined, {
                            maximumFractionDigits: 6
                        })} ${selectedToken} Available`
                        : `0.00 ${selectedToken} Available`
                    }
                </div> : <div className={styles.withDrawAmount}>
                    10,000 USDi minimum
                </div>}


                {/* redeem tab first token selector */}
                <div
                    className={styles.methodItem}
                    onClick={handleMethodItemClick}
                    ref={methodItemRef}
                    style={{
                        marginTop: '45px'
                    }}
                >
                    <div className={styles.withDrawItemLeft}>
                        {selectedToken === "USDT" ? (
                            <img
                                className={styles.withdrawImg}
                                src={usdtImg}
                                alt="usdtImg"
                            />
                        ) : selectedToken === "USDC" ? (
                            <img
                                className={styles.withdrawImg}
                                src={usdcImg}
                                alt="usdcImg"
                            />
                        ) : selectedToken === "CASH" ? (
                            <img
                                className={styles.withdrawImg}
                                src={usdImg}
                                alt="cashImg"
                            />
                        ) : null}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                background: "#1c1c1c",
                                height:"46.2px"
                            }}
                        >
                            <h4>Pay with</h4>
                            {selectedToken === "CASH" ? (
                                <h5>USD Cash</h5>
                            ) : (
                                <h5>{shortenAddress(walletAddress)}</h5>
                            )}
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <div className={styles.withDrawItemRight}>

                                {selectedToken === "CASH" ? (
                                    <h5>
                                        <span style={{
                                            color: (selectedToken !== "CASH" && !enoughBalance) || (selectedToken === "CASH" && typedAmount < 10000 && typedAmount !== 0) ? 'red' : 'white',

                                        }} className={styles.payWithValue}>
                                             {typedMintValue
                                                 ? (
                                                     (Math.ceil(parseFloat(typedMintValue) * 100) / 100).toLocaleString('en-US', {maximumFractionDigits: 6})
                                                 ) : '0.00'
                                             }
                                        </span>
                                        {' '} USD
                                    </h5>
                                ) : (
                                    <h5>
                                        <span className={styles.payWithValue}
                                              style={{color: !enoughBalance ? 'red' : 'inherit'}}>
                                            {parseFloat(typedMintValue).toLocaleString('en-US', {maximumFractionDigits: 6})}
                                        </span>
                                        {' '}{selectedToken}
                                    </h5>
                                )}
                        </div>
                        {showTokenSelector ? (
                            <img
                                src={dropDownImg}
                                className={styles.arrowDown}
                                alt="arrow"
                                onMouseEnter={(e) => (e.currentTarget.src = dropDownHoverImg)}
                                onMouseLeave={(e) => (e.currentTarget.src = dropDownImg)}
                            />
                        ) : (
                            <img
                                src={dropDownRightImg}
                                className={styles.arrowDown}
                                alt="arrow"
                                onMouseEnter={(e) => (e.currentTarget.src = dropDownRightHoverImg)}
                                onMouseLeave={(e) => (e.currentTarget.src = dropDownRightImg)}
                            />
                        )}
                    </div>
                </div>

                {selectedToken === "CASH" && (
                    <img
                        className={styles.verticalLine}
                        src={verticalLineImg}
                        alt="verticalLine"
                    />
                )}

                {/* second token selector */}
                {selectedToken === "CASH" && (
                    <div
                        className={styles.methodItem}
                        onClick={handleMethodItemClick3}
                        ref={methodItemRef3}
                        style={{marginTop: '0px'}}
                    >
                        <div className={styles.withDrawItemLeft}>
                            <img
                                className={styles.withdrawImg}
                                src={methodIcon}
                                alt="paymentMethodIcon"
                            />
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-around",
                                    background: "#1c1c1c"
                                }}
                            >
                                <h4>Payment Method</h4>
                                {paymentInfoData ? (
                                    <h5>Wire transfer</h5>
                                ) : (
                                    <h5>Select Payment Method</h5>
                                )}
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <div className={styles.withDrawItemRight}>
                                <h5 style={{color: "#828787"}}>
                                    {selectedPaymentMethod?.processing_time || ''}
                                </h5>
                                {/*<h5 style={{color: "#54A792"}}>*/}
                                {/*    {selectedPaymentMethod?.fees || 'Fees apply'}*/}
                                {/*</h5>*/}
                            </div>
                            {showTokenSelector3 ? (
                                <img
                                    src={dropDownImg}
                                    className={styles.arrowDown}
                                    alt="arrow"
                                    onMouseEnter={(e) => (e.currentTarget.src = dropDownHoverImg)}
                                    onMouseLeave={(e) => (e.currentTarget.src = dropDownImg)}
                                />
                            ) : (
                                <img
                                    src={dropDownRightImg}
                                    className={styles.arrowDown}
                                    alt="arrow"
                                    onMouseEnter={(e) => (e.currentTarget.src = dropDownRightHoverImg)}
                                    onMouseLeave={(e) => (e.currentTarget.src = dropDownRightImg)}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Token Selector Modal (Redeem) */}
            {showTokenSelector && (
                <div
                    ref={tokenSelectorRef}
                    className={
                        userClass.split(" ")[1] !== "VIP"
                            ? `${styles.tokenSelectorModal}`
                            : `${styles.tokenSelectorModal} ${styles.tokenSelectorModal4}`
                    }
                >
                    <div className={styles.tokenSelectorTitleContainer}>
                        <div className={styles.tokenSelectorTitle}>Token</div>
                        <div className={styles.tokenSelectorTitle}>Balance/Address</div>
                    </div>
                    <div className={styles.tokenSelectorContentContainer}
                         style={{
                             borderRadius: userClass.split(" ")[1] !== "VIP" ? '0 0 15px 15px' : '0'
                         }}>
                        {/* Cash Row only display to VIP*/}
                        {userClass.split(" ")[1] === "VIP" && (
                            <div
                                className={
                                    selectedToken === 'CASH'
                                        ? `${styles.tokenSelectorContent} ${styles.noHover}`
                                        : styles.tokenSelectorContent
                                }
                                onClick={() => handleSelectToken("CASH")}
                            >
                                <div className={styles.tokenSelectorContentLeft}>
                                    <img
                                        className={styles.selectorImg}
                                        src={usdImg}
                                        alt="wireTransferImg"
                                    />
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}>
                                        <h4 style={{marginBottom: '3px'}}>CASH</h4>
                                        <h5 style={{marginBottom: '0'}}>USD Cash</h5>
                                    </div>
                                </div>
                                <div className={styles.tokenSelectorWalletContainer}>
                                    <div style={{textAlign: "right"}}>--</div>
                                    <div>
                                        <span className={styles.tokenSelectorContentRightGrey}>C2C Network</span>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* USDC Row */}
                        <div
                            className={
                                selectedToken === 'USDC'
                                    ? `${styles.tokenSelectorContent} ${styles.noHover}`
                                    : styles.tokenSelectorContent
                            }
                            onClick={() => handleSelectToken("USDC")}
                        >
                            <div className={styles.tokenSelectorContentLeft}>
                                <img
                                    className={styles.selectorImg}
                                    src={usdcImg}
                                    alt="wireTransferImg"
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <h4 style={{marginBottom: '3px'}}>USDC</h4>
                                    <h5 style={{marginBottom: '0'}}>USD Coin</h5>
                                </div>
                            </div>
                            <div className={styles.tokenSelectorWalletContainer}>
                                {usdcBalance ? (
                                    <div
                                        className={styles.tokenSelectorContentRight}
                                        style={
                                            selectedToken === 'USDC'
                                                ? {background: '#2b3336'}
                                                : {}
                                        }
                                    >
                                        {usdcBalance.toLocaleString('en-US', {
                                            maximumFractionDigits: 6
                                        })}
                                    </div>) : (
                                    <div
                                        style={{
                                            textAlign: 'right',
                                            background: selectedToken === 'USDC'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                    >
                                        --
                                    </div>
                                )}
                                <div>
                                    <span
                                        className={styles.tokenSelectorContentRightGrey}
                                        style={{
                                            background: selectedToken === 'USDC'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                        onClick={(e) => handleCopy(e, usdcTokenAddress, 'USDC')}
                                    >
                                        {shortenAddress(usdcTokenAddress)}
                                    </span>
                                    <span>
                                        {justCopiedUSDC ? (
                                            <img
                                                className={styles.tokenSelectorContentRightGreyIMG}
                                                src={copyConfirmImg}
                                                alt="Copied!"
                                                style={{
                                                    background: selectedToken === 'USDC'
                                                        ? '#2b3336'
                                                        : 'transparent',
                                                    width: '11px',
                                                    height: '11px',
                                                    marginLeft: "6px"
                                                }}
                                            />
                                        ) : (
                                            <img
                                                className={styles.tokenSelectorContentRightGreyIMG}
                                                src={copySelectorImg}
                                                alt="copy img"
                                                style={{
                                                    background: selectedToken === 'USDC'
                                                        ? '#2b3336'
                                                        : 'transparent'
                                                }}
                                                onClick={(e) => handleCopy(e, usdcTokenAddress, 'USDC')}
                                                onMouseEnter={(e) =>
                                                    (e.currentTarget.src = copySelectorHoverImg)
                                                }
                                                onMouseLeave={(e) =>
                                                    (e.currentTarget.src = copySelectorImg)
                                                }
                                            />
                                        )}
                                    </span>
                                    <span>
                                       <img
                                           className={styles.tokenSelectorContentRightGreyIMG}
                                           src={shareSelectorImg}
                                           alt="share img"
                                           style={{
                                               background: selectedToken === 'USDC'
                                                   ? '#2b3336'
                                                   : 'transparent'
                                           }}
                                           onClick={(e) => handleShare(e, usdcTokenAddress)}
                                           onMouseEnter={(e) =>
                                               (e.currentTarget.src = shareSelectorHoverImg)
                                           }
                                           onMouseLeave={(e) =>
                                               (e.currentTarget.src = shareSelectorImg)
                                           }
                                       />

                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* USDT Row */}
                        <div
                            className={
                                selectedToken === 'USDT'
                                    ? `${styles.tokenSelectorContent} ${styles.noHover}`
                                    : styles.tokenSelectorContent
                            }
                            onClick={() => handleSelectToken("USDT")}
                            style={{
                                borderRadius: userClass.split(" ")[1] !== "VIP" ? '0 0 15px 15px' : '0'
                            }}
                        >
                            <div className={styles.tokenSelectorContentLeft}>
                                <img
                                    className={styles.selectorImg}
                                    src={usdtImg}
                                    alt="wireTransferImg"
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <h4 style={{marginBottom: '0px'}}>USDT</h4>
                                    <h5 style={{marginBottom: '0'}}>USDT</h5>
                                </div>
                            </div>
                            <div className={styles.tokenSelectorWalletContainer}>
                                {usdtBalance ? (
                                    <div
                                        className={styles.tokenSelectorContentRight}
                                        style={{
                                            background: selectedToken === 'USDT'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                    >
                                        {usdtBalance.toLocaleString('en-US', {
                                            maximumFractionDigits: 6
                                        })}
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            textAlign: 'right',
                                            background: selectedToken === 'USDT'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                    >
                                        --
                                    </div>
                                )}
                                <div>
                                     <span
                                         className={styles.tokenSelectorContentRightGrey}
                                         style={{
                                             background: selectedToken === 'USDT'
                                                 ? '#2b3336'
                                                 : 'transparent'
                                         }}
                                         onClick={(e) => handleCopy(e, usdtTokenAddress, 'USDT')}
                                     >
                                        {shortenAddress(usdtTokenAddress)}
                                    </span>
                                    <span
                                        style={{
                                            background: selectedToken === 'USDT'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                    >
                                                            {justCopiedUSDT ? (
                                                                <img
                                                                    className={styles.tokenSelectorContentRightGreyIMG}
                                                                    src={copyConfirmImg}
                                                                    alt="Copied!"
                                                                    style={{
                                                                        background: selectedToken === 'USDT'
                                                                            ? '#2b3336'
                                                                            : 'transparent',
                                                                        width: '11px',
                                                                        height: '11px',
                                                                        marginLeft: "6px"
                                                                    }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    className={styles.tokenSelectorContentRightGreyIMG}
                                                                    src={copySelectorImg}
                                                                    style={{
                                                                        background: selectedToken === 'USDT'
                                                                            ? '#2b3336'
                                                                            : 'transparent'
                                                                    }}
                                                                    alt="copy img"
                                                                    onClick={(e) => handleCopy(e, usdtTokenAddress, 'USDT')}
                                                                    onMouseEnter={(e) =>
                                                                        (e.currentTarget.src = copySelectorHoverImg)
                                                                    }
                                                                    onMouseLeave={(e) =>
                                                                        (e.currentTarget.src = copySelectorImg)
                                                                    }
                                                                />
                                                            )}
                                                        </span>
                                    <span
                                        style={{
                                            background: selectedToken === 'USDT'
                                                ? '#2b3336'
                                                : 'transparent'
                                        }}
                                    >
                                                            <img
                                                                className={styles.tokenSelectorContentRightGreyIMG}
                                                                src={shareSelectorImg}
                                                                alt="share img"
                                                                style={{
                                                                    background: selectedToken === 'USDT'
                                                                        ? '#2b3336'
                                                                        : 'transparent'
                                                                }}
                                                                onClick={(e) => handleShare(e, usdtTokenAddress)}
                                                                onMouseEnter={(e) =>
                                                                    (e.currentTarget.src = shareSelectorHoverImg)
                                                                }
                                                                onMouseLeave={(e) =>
                                                                    (e.currentTarget.src = shareSelectorImg)
                                                                }
                                                            />
                                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Token Selector Modal 2 (Redeem) */}
            {showTokenSelector3 && (
                <div
                    ref={tokenSelectorRef3}
                    className={`${styles.tokenSelectorModal} ${styles.tokenSelectorModal3}`}
                    style={{height: "110px"}}
                >
                    <div className={styles.tokenSelectorTitleContainer}>
                        <div className={styles.tokenSelectorTitle}>Method</div>
                        <div className={styles.tokenSelectorTitle}>ETA/Fees</div>
                    </div>
                    <div className={styles.tokenSelectorContentContainer} style={{borderRadius: "15px"}}>
                        {paymentInfoData.length === 0 ? (
                            <div style={{height: "7px"}}>
                            </div>
                        ) : (
                            paymentInfoData.map((item) => {
                                const isSelected = selectedPaymentMethod
                                    && selectedPaymentMethod.payment_info_id === item.payment_info_id;
                                const paymentMethodIcon = iconMap[item.payment_method] || WireIcon;
                                const displayValue = getPaymentInfoDisplay(item);

                                return (
                                    <div
                                        key={item.payment_info_id}
                                        className={
                                            isSelected
                                                ? `${styles.tokenSelectorContent} ${styles.noHover}`
                                                : styles.tokenSelectorContent
                                        }
                                        style={isSelected ? {
                                            background: '#2b3336',
                                            borderRadius: "15px"
                                        } : {borderRadius: "15px"}}
                                        // todo maybe need to change it back in the future
                                        // onClick={() => {
                                        //     setSelectedPaymentMethod(item);
                                        //     handleSelectPaymentMethod(item);
                                        // }}
                                    >
                                        <div className={styles.tokenSelectorContentLeft}>
                                            <img
                                                className={styles.selectorImg}
                                                src={paymentMethodIcon}
                                                alt="PaymentMethodIcon"
                                            />
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <h4 style={{marginBottom: '3px'}}>
                                                    {item.payment_method}
                                                </h4>
                                                <h5 style={{marginBottom: '0'}}>
                                                    {displayValue}
                                                </h5>
                                            </div>
                                        </div>

                                        <div className={styles.tokenSelectorWalletContainer}>
                                            <div
                                                style={{textAlign: "right"}}>    {item?.processing_time || '1-3 biz days'}
                                            </div>
                                            <div style={{textAlign: "right"}}>
                                                <span
                                                    className={styles.tokenSelectorContentRightGreen}
                                                >
                                                        {item?.fees || 'Fees apply'}

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}

                    </div>
                </div>
            )}

            {walletAddressExists ? (
                selectedToken !== "CASH" && !enoughBalance ? (
                    <button disabled style={{opacity: 0.5, background: 'white'}}>
                        Insufficient {selectedToken}
                    </button>
                ) : selectedToken === "CASH" && typedAmount !== 0 && typedAmount < 10000 ? (
                    <button disabled style={{opacity: 0.5, background: 'white'}}>
                        10,000 USDi minimum
                    </button>
                ) : selectedToken === "CASH" ? (
                    <button
                        onClick={() => {
                            if (typedAmount === 0) {
                                showNotification('error', 'Please enter a valid amount to mint.');
                                return;               // 不再执行后续逻辑
                            }
                            setShowWireTransfer(true);
                        }}
                    >
                        Mint USDi
                    </button>
                ) : (
                    <button onClick={handleMintUSDi}>
                        Mint USDi
                    </button>
                )
            ) : (
                <button onClick={handleConnectWallet}>Connect Wallet</button>
            )}

            {showWireTransfer && (
                <WireTransfer
                    onClose={() => setShowWireTransfer(false)}
                    paymentInfo={paymentInfoData[0]}
                    onConfirm={() => {
                        setShowWireTransfer(false);
                        setShowWireDetails(true);
                    }}
                />
            )}
            {showWireDetails && (
                <WireDetails
                    onClose={() => setShowWireDetails(false)}
                    onBack={() => {
                        setShowWireDetails(false);
                        setShowWireTransfer(true);
                    }}
                />
            )}
        </div>
    );
};

export default MintTab;
